import Button from '@mui/material/Button';
import React from 'react';

interface FillButtonProps {
  name: string;
  onClick?: () => void; 
  disabled:any;
}

const FillButton: React.FC<FillButtonProps> = ({ name, onClick,disabled }) => {
  return (
    <div>
      <Button
        className='w-80 bg-customBlue'
        variant="contained"
        sx={{ textTransform: "none", borderRadius: "25px",backgroundColor: "#001a70", 
          '&:hover': {
            backgroundColor: "#143293", 
          } }}
        onClick={onClick}
        disabled={disabled}
        
      >
        {name}
      </Button>
    </div>
  );
};

export default FillButton;
